import type { RouteDef } from '@/app/routes'
import type { WrittenPage } from '../sections'

/**
 * Where a confirmation link lands. See
 * `supabase/migrations/20260908160000_website_newsletter.sql` for the flow.
 *
 * NOINDEX, and that is the only interesting thing about these three pages: they
 * are outcomes of a private action, they say nothing a searcher wants, and a
 * "you are subscribed" page in Google's index is a page somebody arrives at
 * without having subscribed. `robots: 'noindex'` keeps them out of the sitemap
 * as well.
 */
export const route: RouteDef = {
  id: 'newsletterConfirmed',
  path: 'newsletter/confirmed',
  priority: 0.1,
  robots: 'noindex',
}

export const newsletterConfirmed: WrittenPage = {
  navLabel: 'Subscription confirmed',
  title: 'You are subscribed',
  description: 'Your newsletter subscription is confirmed.',
  sections: [
    {
      kind: 'prose',
      align: 'center',
      heading: 'You are subscribed',
      sub: 'Thank you — that is all it took.',
      paragraphs: [
        'The next issue goes out on the second Tuesday of the month. It is one email: what we are seeing in digital and AI transformation, what the data says, and what we would do about it.',
        'Every issue carries an unsubscribe link, and it works in one click.',
      ],
      cta: { label: 'Back to the site', href: '/' },
    },
  ],
}
